// src/pages/organismos/Fopremas.jsx

const miembrosFopremas = [
  { cargo: "Presidente", nombre: "Raúl Augusto Bisso Jauregui", logia: "212", tratamiento: "R.·. H.·." },
  { cargo: "Vice Presidente", nombre: "Ronal Pinto de la Sota Silva", logia: "133", tratamiento: "R.·. H.·." },
  { cargo: "Secretario", nombre: "Antonio Edwin Herquinio Arias", logia: "42", tratamiento: "R.·. H.·." },
  { cargo: "Tesorero", nombre: "Emigdio Augusto Vargas Ulloa", logia: "34", tratamiento: "R.·. H.·." },
  { cargo: "Auditor Interno", nombre: "José Martín Rivera Paredes", logia: "78", tratamiento: "R.·. H.·." },
  { cargo: "Vocal", nombre: "Luis Alberto Tejada Tejada", logia: "107", tratamiento: "R.·. H.·." },
  { cargo: "Vocal", nombre: "José Antonio Castro Palacios", logia: "69", tratamiento: "Q.·. H.·." }
];

const Fopremas = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=2000&auto=format&fit=crop')" }} // Imagen sugerida de finanzas/seguridad/arquitectura clásica
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Fondo de Previsión Masónica
          </p>
          <h1 className="font-serif text-4xl md:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-6">
            FOPREMAS
          </h1>
          <p className="text-gray-400 font-light text-sm tracking-widest animate-fade-in [animation-delay:0.6s]">
            11 de Noviembre 2025
          </p>
        </div>
      </section>

      {/* Contenido Principal */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24 flex-grow w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          
          {/* COLUMNA IZQUIERDA: Directorio y Decretos */}
          <div className="lg:col-span-7 flex flex-col gap-16">
            
            {/* Miembros del FOPREMAS */}
            <div>
              <div className="mb-8 border-b border-white/10 pb-4 flex flex-col sm:flex-row justify-between sm:items-end gap-4">
                <h3 className="font-serif text-2xl md:text-3xl text-white">
                  Consejo Directivo
                </h3>
                <div className="text-left sm:text-right">
                  <p className="text-[#C5A059] text-[10px] tracking-widest uppercase border border-[#C5A059]/30 px-3 py-1 inline-block bg-[#C5A059]/5">
                    Decreto N° 142-121 GLP
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Presidente destacado */}
                <div className="md:col-span-2 bg-gradient-to-br from-[#0a0a0a] to-[#111111] border-t-2 border-[#C5A059] p-6 shadow-lg">
                  <span className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{miembrosFopremas[0].cargo}</span>
                  <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">{miembrosFopremas[0].tratamiento}</p>
                  <h4 className="font-serif text-2xl text-white mb-2">{miembrosFopremas[0].nombre}</h4>
                  <p className="text-gray-400 text-xs font-light tracking-wide">Logia N° {miembrosFopremas[0].logia}</p>
                </div>
                
                {/* Resto de miembros */}
                {miembrosFopremas.slice(1).map((miembro, idx) => (
                  <div key={idx} className="bg-[#0a0a0a] border border-white/5 p-6 hover:border-[#C5A059]/30 transition-colors">
                    <span className="text-gray-400 text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{miembro.cargo}</span>
                    <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">{miembro.tratamiento}</p>
                    <h4 className="font-serif text-lg md:text-xl text-white mb-2">{miembro.nombre}</h4>
                    <p className="text-gray-400 text-xs font-light tracking-wide">Logia N° {miembro.logia}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Visualizador de Decretos (Imágenes) */}
            <div>
              <div className="mb-6 border-b border-white/10 pb-4">
                <h3 className="font-serif text-2xl md:text-3xl text-white">
                  Documento Oficial (Decreto)
                </h3>
                <p className="text-gray-400 text-sm font-light mt-2">
                  Haga clic en las imágenes para ampliar la lectura del Decreto N° 142-121 GLP.
                </p>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {/* Asegúrate de que las imágenes existan en tu carpeta public con estos nombres */}
                <a href="/decreto_fopremas_1.jpg" target="_blank" rel="noopener noreferrer" className="group block aspect-[3/4] bg-gray-900 border border-white/10 overflow-hidden relative shadow-lg">
                  <img src="/decreto_fopremas_1.jpg" alt="Decreto FOPREMAS Página 1" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-white border border-white px-4 py-2 text-xs tracking-widest uppercase bg-black/50 backdrop-blur-sm">Ampliar Imagen</span>
                  </div>
                </a>
                
                <a href="/decreto_fopremas_2.jpg" target="_blank" rel="noopener noreferrer" className="group block aspect-[3/4] bg-gray-900 border border-white/10 overflow-hidden relative shadow-lg">
                  <img src="/decreto_fopremas_2.jpg" alt="Decreto FOPREMAS Página 2" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-white border border-white px-4 py-2 text-xs tracking-widest uppercase bg-black/50 backdrop-blur-sm">Ampliar Imagen</span>
                  </div>
                </a>
              </div>
            </div>

          </div>

          {/* COLUMNA DERECHA: Descargas y Contacto (Sticky) */}
          <div className="lg:col-span-5">
            <div className="sticky top-32 flex flex-col gap-8">
              
              {/* Call to Action: Descarga de Formato */}
              <div className="bg-gradient-to-br from-[#C5A059] to-[#9A7B3E] p-1 shadow-2xl">
                <div className="bg-[#050505] p-8 md:p-10 text-center">
                  <h3 className="font-serif text-2xl text-white mb-4">Declaración 2025</h3>
                  <p className="text-gray-400 text-sm font-light mb-8">
                    Descargue el formato oficial para realizar su declaración anual al Fondo de Previsión Masónica.
                  </p>
                  <a 
                    href="/formato_declaracion_fopremas_2025.pdf" // Ruta al archivo PDF en public
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col items-center justify-center gap-2 bg-[#C5A059] hover:bg-white text-[#050505] transition-colors duration-300 py-4 px-6 w-full group"
                  >
                    <svg className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                    <span className="text-xs md:text-sm font-bold tracking-[0.1em] uppercase">
                      Descargar Formato
                    </span>
                  </a>
                </div>
              </div>

              {/* Tarjeta de Contacto */}
              <div className="bg-[#0a0a0a] border border-white/5 p-8 md:p-10 shadow-xl">
                <h3 className="font-serif text-2xl text-white mb-8 border-b border-white/10 pb-4">
                  Información de Contacto
                </h3>
                
                <div className="space-y-8">
                  <div>
                    <span className="flex items-center gap-3 text-[#C5A059] text-xs tracking-[0.2em] uppercase mb-2">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                      Dirección
                    </span>
                    <p className="text-gray-300 font-light text-sm pl-7">
                      Av. José Gálvez Barrenechea N°599
                      <span className="block text-gray-500 mt-1">Tercer piso, San Isidro</span>
                    </p>
                  </div>

                  <div>
                    <span className="flex items-center gap-3 text-[#C5A059] text-xs tracking-[0.2em] uppercase mb-2">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                      Central Telefónica
                    </span>
                    <p className="text-gray-300 font-light text-sm pl-7">
                      618-5454 <span className="text-[#C5A059] mx-1">|</span> Anexos: 211 / 618-5466
                    </p>
                  </div>

                  <div>
                    <span className="flex items-center gap-3 text-[#C5A059] text-xs tracking-[0.2em] uppercase mb-2">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                      Correo Electrónico
                    </span>
                    <a href="mailto:fopremas@glperu.org.pe" className="text-gray-300 hover:text-[#C5A059] transition-colors font-light text-sm pl-7 block">
                      fopremas@glperu.org.pe
                    </a>
                  </div>

                  <div className="bg-white/5 p-4 border-l-2 border-[#C5A059]">
                    <span className="text-gray-400 text-[10px] tracking-widest uppercase block mb-1">Atención</span>
                    <p className="text-white font-medium text-sm">Sr. Paulino Yucra Ñaupa</p>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Fopremas;